import { Epic, ofType } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    UpdateInternalBannerTemplateResources,
    updateInternalBannerTemplateResourcesAction
} from '../../../actions/bannersEdit/internal/updateInternalBannerTemplateResources';
import {
    UpdateInternalBannerImage,
    updateInternalBannerImageAction
} from '../../../actions/imageEditor/internal/updateInternalBannerImage';
import {
    UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY,
    UpdateInternalBannerImageByGallery
} from '../../../actions/imageEditor/internal/updateInternalBannerImageByGallery';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { EpicDeps } from '../../../service/StoreFactory';
import { getBannerWithImage, MassActionId } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

type EpicActions = UpdateInternalBannerImage | UpdateInternalBannerTemplateResources;

export const updateInternalBannerImageByGalleryEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY),
        mergeMap(
            (action: UpdateInternalBannerImageByGallery): Observable<EpicActions> => {
                const state = store$.value;
                const { bannerId, resourceId } = action;

                if (bannerId === MassActionId.bannersEdit) {
                    return EMPTY;
                }

                const imagesHash = action.imagesHash[0];
                const banner = getBannerWithImage(state.editInternalBanners.banners[bannerId]);

                if (banner && imagesHash) {
                    const imageEditorId = getImageEditorIdByBannerId(bannerId, resourceId);
                    const { imageGallery } = state.imageEditor[imageEditorId];
                    const image = imageGallery.images && imageGallery.images.find(({ hash }) => imagesHash === hash);

                    if (image) {
                        return of(
                            updateInternalBannerImageAction(bannerId, resourceId, image),
                            updateInternalBannerTemplateResourcesAction(bannerId, resourceId, image.hash)
                        );
                    }
                }

                return EMPTY;
            }
        )
    );
};
